import { apiGet, apiDelete } from '@/lib/api';
import type { UserDevice } from '@troia-v3/types';

/**
 * Devices API Service
 * Handles listing and removing devices registered by the current user
 * (used by push notification dedupe / 2FA device lifecycle).
 */
export const devicesApi = {
  getMyDevices: (signal?: AbortSignal): Promise<UserDevice[]> =>
    apiGet<UserDevice[]>('users/me/devices', signal ? { signal } : undefined),

  deleteDevice: (deviceId: string): Promise<void> => apiDelete(`users/me/devices/${deviceId}`),
};
